'use strict';

module.exports = {        
    // Only used by the Product Page Item Schema:
    site: 'https://strongproject.com',

    // Used for static images directory
    static: '/static/', // (= PHP define STATIC_URL), with trailing slash

    Breaks: {
        MobilePortraitMin: 300,
        MobilePortraitMax: 600,
        MobileLandscapeMax: 750,
        
        MobileMin: 300,
        MobileMax: 750,

        DesktopWidth: 1150,
    },
};



// WEBPACK FOOTER //
// ./src/constants/constants.js